/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItems_user$ref = any;
export type CartLayout_user$ref = any;
export type CartLayout_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": CartItems_user$ref;
    readonly " $refType": CartLayout_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartLayout_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartItems_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c5fbeaea65ab8b27d4b13452eea29968';
export default node;
